import { fixMaybeBrokenText } from "@/lib/text";

export type SiteRegion = {
  code: string;
  city: string;
  area: string;
  label: string;
  latitude: number;
  longitude: number;
  scope: "moscow" | "moscow-region" | "russia";
};

export type PickupLocation = {
  code: string;
  title: string;
  city: string;
  area: string;
  address: string;
  shortAddress: string;
  schedule: string;
  leadTime: string;
  latitude: number;
  longitude: number;
};

export type AddressSuggestion = {
  id: string;
  city: string;
  area: string;
  regionLabel: string;
  shortLabel: string;
  fullAddress: string;
  scope: "moscow" | "moscow-region" | "russia";
  latitude?: number | null;
  longitude?: number | null;
  postalCode?: string;
  source?: "seed" | "live";
};

const rawKnownRegions: SiteRegion[] = [
  {
    code: "msk",
    city: "Москва",
    area: "Москва",
    label: "Москва",
    latitude: 55.7558,
    longitude: 37.6173,
    scope: "moscow"
  },
  {
    code: "odintsovo",
    city: "Одинцово",
    area: "Московская область",
    label: "МО, Одинцово",
    latitude: 55.655104,
    longitude: 37.281028,
    scope: "moscow-region"
  },
  {
    code: "khimki",
    city: "Химки",
    area: "Московская область",
    label: "МО, Химки",
    latitude: 55.8887,
    longitude: 37.4302,
    scope: "moscow-region"
  },
  {
    code: "domodedovo",
    city: "Домодедово",
    area: "Московская область",
    label: "МО, Домодедово",
    latitude: 55.4367,
    longitude: 37.7661,
    scope: "moscow-region"
  },
  {
    code: "krasnogorsk",
    city: "Красногорск",
    area: "Московская область",
    label: "МО, Красногорск",
    latitude: 55.8319,
    longitude: 37.329,
    scope: "moscow-region"
  },
  {
    code: "mytishchi",
    city: "Мытищи",
    area: "Московская область",
    label: "МО, Мытищи",
    latitude: 55.9105,
    longitude: 37.736,
    scope: "moscow-region"
  },
  {
    code: "balashikha",
    city: "Балашиха",
    area: "Московская область",
    label: "МО, Балашиха",
    latitude: 55.7963,
    longitude: 37.9382,
    scope: "moscow-region"
  },
  {
    code: "spb",
    city: "Санкт-Петербург",
    area: "Россия",
    label: "Санкт-Петербург",
    latitude: 59.9311,
    longitude: 30.3609,
    scope: "russia"
  },
  {
    code: "ekb",
    city: "Екатеринбург",
    area: "Россия",
    label: "Екатеринбург",
    latitude: 56.8389,
    longitude: 60.6057,
    scope: "russia"
  }
];

export const knownRegions = fixMaybeBrokenText(rawKnownRegions) as SiteRegion[];

export const defaultRegion = knownRegions[0];

const rawPickupLocations: PickupLocation[] = [
  {
    code: "ODN-AKOS-M43-44",
    title: "Самовывоз из ТЦ «АКОС»",
    city: "Одинцово",
    area: "Московская область",
    address: "Московская область, г. Одинцово, ул. Внуковская, д. 11, ТЦ «АКОС», пав. М43-44",
    shortAddress: "г. Одинцово, ул. Внуковская, д. 11, ТЦ «АКОС», пав. М43-44",
    schedule: "пн-вс · с 09:00 до 19:00",
    leadTime: "Сегодня или на следующий рабочий день",
    latitude: 55.655104,
    longitude: 37.281028
  }
];

export const pickupLocations = fixMaybeBrokenText(rawPickupLocations) as PickupLocation[];

const rawAddressSuggestions: AddressSuggestion[] = [
  {
    id: "msk-tverskaya-7",
    city: "Москва",
    area: "Москва",
    regionLabel: "Москва",
    shortLabel: "Тверская улица, 7",
    fullAddress: "Москва, Тверская улица, 7",
    scope: "moscow"
  },
  {
    id: "msk-leningradka-37",
    city: "Москва",
    area: "Москва",
    regionLabel: "Москва",
    shortLabel: "Ленинградский проспект, 37",
    fullAddress: "Москва, Ленинградский проспект, 37",
    scope: "moscow"
  },
  {
    id: "msk-domodedovskaya-12",
    city: "Москва",
    area: "Москва",
    regionLabel: "Москва",
    shortLabel: "Домодедовская улица, 12",
    fullAddress: "Москва, Домодедовская улица, 12",
    scope: "moscow"
  },
  {
    id: "msk-domodedovskaya-28",
    city: "Москва",
    area: "Москва",
    regionLabel: "Москва",
    shortLabel: "Домодедовская улица, 28",
    fullAddress: "Москва, Домодедовская улица, 28",
    scope: "moscow"
  },
  {
    id: "msk-domodedovskaya-34k2",
    city: "Москва",
    area: "Москва",
    regionLabel: "Москва",
    shortLabel: "Домодедовская улица, 34к2",
    fullAddress: "Москва, Домодедовская улица, 34к2",
    scope: "moscow"
  },
  {
    id: "msk-kutuzovskiy-36",
    city: "Москва",
    area: "Москва",
    regionLabel: "Москва",
    shortLabel: "Кутузовский проспект, 36с4",
    fullAddress: "Москва, Кутузовский проспект, 36с4",
    scope: "moscow"
  },
  {
    id: "msk-varshavskoe-1",
    city: "Москва",
    area: "Москва",
    regionLabel: "Москва",
    shortLabel: "Варшавское шоссе, 1с1",
    fullAddress: "Москва, Варшавское шоссе, 1с1",
    scope: "moscow"
  },
  {
    id: "odn-vnukovskaya-11",
    city: "Одинцово",
    area: "Московская область",
    regionLabel: "МО, Одинцово",
    shortLabel: "ул. Внуковская, 11",
    fullAddress: "Московская область, Одинцово, ул. Внуковская, 11",
    scope: "moscow-region",
    latitude: 55.655104,
    longitude: 37.281028
  },
  {
    id: "odn-mozhayskoe-71",
    city: "Одинцово",
    area: "Московская область",
    regionLabel: "МО, Одинцово",
    shortLabel: "Можайское шоссе, 71",
    fullAddress: "Московская область, Одинцово, Можайское шоссе, 71",
    scope: "moscow-region"
  },
  {
    id: "odn-chikina-8",
    city: "Одинцово",
    area: "Московская область",
    regionLabel: "МО, Одинцово",
    shortLabel: "улица Чикина, 8А",
    fullAddress: "Московская область, Одинцово, улица Чикина, 8А",
    scope: "moscow-region"
  },
  {
    id: "khimki-leningradskaya-25",
    city: "Химки",
    area: "Московская область",
    regionLabel: "МО, Химки",
    shortLabel: "Ленинградская улица, 25",
    fullAddress: "Московская область, Химки, Ленинградская улица, 25",
    scope: "moscow-region"
  },
  {
    id: "khimki-panfilova-19",
    city: "Химки",
    area: "Московская область",
    regionLabel: "МО, Химки",
    shortLabel: "улица Панфилова, 19",
    fullAddress: "Московская область, Химки, улица Панфилова, 19",
    scope: "moscow-region"
  },
  {
    id: "dom-kashirskoe-7",
    city: "Домодедово",
    area: "Московская область",
    regionLabel: "МО, Домодедово",
    shortLabel: "Каширское шоссе, 7",
    fullAddress: "Московская область, Домодедово, Каширское шоссе, 7",
    scope: "moscow-region"
  },
  {
    id: "dom-korneeva-27",
    city: "Домодедово",
    area: "Московская область",
    regionLabel: "МО, Домодедово",
    shortLabel: "улица Корнеева, 27",
    fullAddress: "Московская область, Домодедово, улица Корнеева, 27",
    scope: "moscow-region"
  },
  {
    id: "krg-lenina-3",
    city: "Красногорск",
    area: "Московская область",
    regionLabel: "МО, Красногорск",
    shortLabel: "улица Ленина, 3",
    fullAddress: "Московская область, Красногорск, улица Ленина, 3",
    scope: "moscow-region"
  },
  {
    id: "myt-letnaya-40",
    city: "Мытищи",
    area: "Московская область",
    regionLabel: "МО, Мытищи",
    shortLabel: "Лётная улица, 40",
    fullAddress: "Московская область, Мытищи, Лётная улица, 40",
    scope: "moscow-region"
  },
  {
    id: "bal-sovetskaya-36",
    city: "Балашиха",
    area: "Московская область",
    regionLabel: "МО, Балашиха",
    shortLabel: "Советская улица, 36к2",
    fullAddress: "Московская область, Балашиха, Советская улица, 36к2",
    scope: "moscow-region"
  },
  {
    id: "spb-nevsky-28",
    city: "Санкт-Петербург",
    area: "Россия",
    regionLabel: "Санкт-Петербург",
    shortLabel: "Невский проспект, 28",
    fullAddress: "Санкт-Петербург, Невский проспект, 28",
    scope: "russia"
  },
  {
    id: "ekb-lenina-48",
    city: "Екатеринбург",
    area: "Россия",
    regionLabel: "Екатеринбург",
    shortLabel: "проспект Ленина, 48",
    fullAddress: "Екатеринбург, проспект Ленина, 48",
    scope: "russia"
  }
];

export const addressSuggestions = fixMaybeBrokenText(rawAddressSuggestions) as AddressSuggestion[];

for (const region of knownRegions) {
  Object.assign(region, fixMaybeBrokenText(region));
}

for (const location of pickupLocations) {
  Object.assign(location, fixMaybeBrokenText(location));
}

for (const suggestion of addressSuggestions) {
  Object.assign(suggestion, fixMaybeBrokenText(suggestion));
}

function toRadians(value: number) {
  return (value * Math.PI) / 180;
}

function distanceInKm(
  latitudeA: number,
  longitudeA: number,
  latitudeB: number,
  longitudeB: number
) {
  const earthRadiusKm = 6371;
  const dLat = toRadians(latitudeB - latitudeA);
  const dLon = toRadians(longitudeB - longitudeA);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(latitudeA)) *
      Math.cos(toRadians(latitudeB)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function findNearestRegion(latitude: number, longitude: number) {
  const nearest = knownRegions
    .map((region) => ({
      region,
      distance: distanceInKm(latitude, longitude, region.latitude, region.longitude)
    }))
    .sort((left, right) => left.distance - right.distance)[0];

  if (!nearest || nearest.distance > 250) {
    return defaultRegion;
  }

  return nearest.region;
}

export function findRegionByCityName(value: string) {
  const normalized = value.trim().toLowerCase();

  return (
    knownRegions.find(
      (region) =>
        region.city.trim().toLowerCase() === normalized ||
        region.label.trim().toLowerCase() === normalized
    ) ?? defaultRegion
  );
}

export function inferScopeByArea(city: string, area: string) {
  const normalizedCity = city.trim().toLowerCase();
  const normalizedArea = area.trim().toLowerCase();

  if (normalizedCity === "москва" || normalizedArea.includes("москва")) {
    return "moscow" as const;
  }

  if (
    normalizedArea.includes("московская область") ||
    knownRegions.some(
      (region) =>
        region.scope === "moscow-region" && region.city.trim().toLowerCase() === normalizedCity
    )
  ) {
    return "moscow-region" as const;
  }

  return "russia" as const;
}

export function formatRegionLabel(city: string, area: string) {
  const scope = inferScopeByArea(city, area);

  if (scope === "moscow") {
    return "Москва";
  }

  if (scope === "moscow-region") {
    return `МО, ${city}`;
  }

  return city;
}

export function findAddressSuggestions(query: string, region?: SiteRegion) {
  const normalized = query.trim().toLowerCase();
  const filtered = (!normalized
    ? addressSuggestions.filter((item) =>
        region ? item.city.toLowerCase() === region.city.toLowerCase() : item.scope !== "russia"
      )
    : addressSuggestions.filter((item) => {
        const haystack = `${item.fullAddress} ${item.city} ${item.area}`.toLowerCase();
        return haystack.includes(normalized);
      })
  ).map((item) => ({
    ...item,
    source: item.source ?? ("seed" as const)
  }));

  if (!region) {
    return filtered;
  }

  const regionCity = region.city.toLowerCase();
  return filtered.sort((left, right) => {
    const leftScore =
      left.city.toLowerCase() === regionCity ? 0 : left.scope === region.scope ? 1 : 2;
    const rightScore =
      right.city.toLowerCase() === regionCity ? 0 : right.scope === region.scope ? 1 : 2;

    return leftScore - rightScore;
  });
}

export function buildYandexMapWidgetUrl(params: {
  address?: string;
  latitude?: number | null;
  longitude?: number | null;
  zoom?: number;
}) {
  const url = new URL("https://yandex.ru/map-widget/v1/");

  if (typeof params.latitude === "number" && typeof params.longitude === "number") {
    const longitude = params.longitude.toFixed(6);
    const latitude = params.latitude.toFixed(6);
    url.searchParams.set("ll", `${longitude},${latitude}`);
    url.searchParams.set("mode", "whatshere");
    url.searchParams.set("whatshere[point]", `${longitude},${latitude}`);
    url.searchParams.set("whatshere[zoom]", String(params.zoom ?? 15));
    url.searchParams.set("z", String(params.zoom ?? 15));
    return url.toString();
  }

  if (params.address?.trim()) {
    url.searchParams.set("mode", "search");
    url.searchParams.set("text", params.address.trim());
    url.searchParams.set("z", String(params.zoom ?? 14));
  }

  return url.toString();
}

export function buildYandexMapsLink(params: {
  address?: string;
  latitude?: number | null;
  longitude?: number | null;
  zoom?: number;
}) {
  const url = new URL("https://yandex.ru/maps/");

  if (typeof params.latitude === "number" && typeof params.longitude === "number") {
    const longitude = params.longitude.toFixed(6);
    const latitude = params.latitude.toFixed(6);
    url.searchParams.set("ll", `${longitude},${latitude}`);
    url.searchParams.set("mode", "whatshere");
    url.searchParams.set("whatshere[point]", `${longitude},${latitude}`);
    url.searchParams.set("whatshere[zoom]", String(params.zoom ?? 17));
    url.searchParams.set("z", String(params.zoom ?? 17));
    return url.toString();
  }

  if (params.address?.trim()) {
    url.searchParams.set("text", params.address.trim());
  }

  return url.toString();
}

export function buildOpenStreetMapEmbedUrl(params: {
  latitude?: number | null;
  longitude?: number | null;
  zoom?: number;
}) {
  if (typeof params.latitude !== "number" || typeof params.longitude !== "number") {
    return "https://www.openstreetmap.org/export/embed.html?layer=mapnik";
  }

  const latitude = params.latitude;
  const longitude = params.longitude;
  const latDelta = 0.0036;
  const lonDelta = 0.0064;
  const left = (longitude - lonDelta).toFixed(6);
  const bottom = (latitude - latDelta).toFixed(6);
  const right = (longitude + lonDelta).toFixed(6);
  const top = (latitude + latDelta).toFixed(6);
  const marker = `${latitude.toFixed(6)},${longitude.toFixed(6)}`;
  const url = new URL("https://www.openstreetmap.org/export/embed.html");
  url.searchParams.set("bbox", `${left},${bottom},${right},${top}`);
  url.searchParams.set("layer", "mapnik");
  url.searchParams.set("marker", marker);
  return url.toString();
}

export function buildOpenStreetMapLink(params: {
  latitude?: number | null;
  longitude?: number | null;
  zoom?: number;
}) {
  if (typeof params.latitude !== "number" || typeof params.longitude !== "number") {
    return "https://www.openstreetmap.org/";
  }

  const latitude = params.latitude.toFixed(6);
  const longitude = params.longitude.toFixed(6);
  const zoom = params.zoom ?? 17;
  return `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=${zoom}/${latitude}/${longitude}`;
}

export function getPrimaryPickupLocation() {
  return pickupLocations[0];
}
